import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";


@Injectable({
  providedIn: 'root'
})
export class ApiCreditMasterService {

  public ApiEndpoint = 'master/api-credit';

  constructor(private restService: RestService) {
  }

  readBalance(account_id: string) {
    return this.restService.send<{ balance: number }>(
      {
        method: 'GET',
        url: `${this.ApiEndpoint}/balance?account_id=${account_id}`
      }
    )
  }

  async addBalance(amount: any, _id: string) {
    return this.restService.send(
      {
        method: 'POST',
        url: `${this.ApiEndpoint}/balance`,
        body: {
          account_id: _id,
          amount: amount
        }
      }
    )
  }
}
